module.exports = __webpack_public_path__ + "img/contact_email.6f412e0a.svg";